import { createColumnHelper } from '@tanstack/react-table';

import { EnrichedAsset, FilterType } from '../_openapi/portfolio-optimizer';
import { getAvailableAssetClasses, getAvailableAssetTypes, getAvailableSubAssetTypes } from '../utils/assetUtils';
import { AssetClassTag } from '../widgets/AssetClassTag';
import { baseCol, booleanCol, dateCol, textCol } from '../widgets/Table/columnHelpers/colDef';
import { makeFieldAccessors } from '../widgets/Table/columnHelpers/makeFieldAccessors';
import { FlagCell } from '../widgets/Table/FlagCell';

const columnHelper = createColumnHelper<EnrichedAsset>();
const asset = makeFieldAccessors(columnHelper, (row) => row.asset);

export const assetListColumns = [
    asset.text('sId'),
    asset.text('symbol'),
    asset.text('description'),
    asset.date('expirationDate'),
    asset.num('contractMultiplier'),
    asset.num('priceMultiplier'),
    asset.text('ndvrChainId'),
    columnHelper.accessor((row) => row.asset.assetClass, {
        ...baseCol({ id: 'assetClass' }),
        cell: ({ getValue }) => <AssetClassTag assetClass={getValue()} />,
        meta: {
            filterOptionsFn: getAvailableAssetClasses,
            filterType: FilterType.LIST,
        },
    }),
    columnHelper.accessor(
        (row) => row.asset.assetType,
        textCol<EnrichedAsset>({
            id: 'assetType',
            meta: {
                filterOptionsFn: getAvailableAssetTypes,
                filterType: FilterType.LIST,
            },
        }),
    ),
    columnHelper.accessor(
        (row) => row.asset.subAssetType,
        textCol<EnrichedAsset>({
            id: 'subAssetType',
            meta: {
                filterOptionsFn: getAvailableSubAssetTypes,
                filterType: FilterType.LIST,
            },
        }),
    ),
    asset.text('cusip'),
    asset.text('scId'),
    asset.text('coId'),
    asset.text('isin'),
    asset.text('sedol'),
    asset.text('mic'),
    asset.text('gicsCode'),
    asset.text('gicsSector'),
    asset.text('gicsIndustry'),
    asset.text('issuer'),
    asset.text('settlementMethod'),
    asset.text('underlyingSymbol'),
    asset.text('putCall'),
    asset.date('maturityDate'),
    asset.date('firstNoticeDate'),
    asset.date('issueDate'),
    asset.num('coupon'),
    asset.num('minTick'),
    asset.text('primaryExchange'),
    columnHelper.accessor((row) => row.asset.country, {
        ...baseCol({ id: 'country' }),
        cell: ({ getValue }) => <FlagCell alpha3={getValue()} />,
    }),
    asset.text('exchangeProductCode'),
    asset.num('length'),
    asset.text('market', 'Futures Sector'),
    asset.money('strikePrice'),
    columnHelper.accessor('lastHeldDate', dateCol({ id: 'lastHeldDate' })),
    columnHelper.accessor('isLiveHeld', booleanCol({ id: 'isLiveHeld' })),
    asset.bool('isActive'),
];
